<template>
  <GeneralForm :jenisJurnal="2" :title="title" :routeBack="routeBack" :jurnalUrl="url" />
</template>

<script>
import GeneralForm from '@/views/jurnal/GeneralForm.vue';

export default {
    components: {
        GeneralForm
    },
    data:() => ({
       title : 'Jurnal Rekening Air',
       url : '/api/ju',
       routeBack : 'jralist',
    }),
    methods: {
       
    }
}
</script>


<style>

</style>